<template>
<div class="query-header">
  <el-row
    :gutter="20"
  >
    <cent-select
      ref="centselect"
      v-if="centAccontConfig"
      :tabs-type="tabsType"
      @send-type="sendType"
    ></cent-select>
    <el-col
      :lg="8"
      :md="8"
      :sm="12"
      :xs="24"
    >
<!--      value-format="yyyy-MM-dd HH-mm-ss"-->
      <div class="label">{{$t('Opening_time')}}</div>
      <el-date-picker
        v-if="!realMobile"
        style="width: 100%"
        v-model="date"
        type="daterange"
        value-format="yyyy-MM-dd"
        :range-separator="phFileter('root.dateTo')"
        :start-placeholder="phFileter('root.startDate')"
        :end-placeholder="phFileter('root.endDate')"
        @change="toQuery"
      >
      </el-date-picker>
      <select-date-duration
        class="header-sub-item"
        v-model="date"
      ></select-date-duration>
    </el-col>
  </el-row>
</div>
</template>

<script>

import { mapGetters } from 'vuex';
import { init_date } from '@/utils'
export default {
  name: "queryHeader",
  props: {
    centAccontConfig: {
    },
  },
  data() {
    return {
      date: [], // 时间
      tabsType: 'USD'
    }
  },
  computed: {
    ...mapGetters(['realMobile'])
  },
  created(){
    this.date = [init_date().oneMonAgo,init_date().today];

  },
  methods: {

    phFileter(data) {
      return this.$t(data);
    },
    toQuery(){
      this.$emit('toQuery');
    },
    sendType(tabsType){
      this.tabsType = tabsType;
      this.toQuery();
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .label {
    margin-bottom: 5px;
  }
  .select-date-duration {
    width: 100%;
  }
}
</style>
